const elements = {
  rte: [...document.body.querySelectorAll('.js-rte table')],
};

function init() {
  if (elements.rte.length) {
    elements.rte.forEach((el) => {
      const tableWrapper = document.createElement('div');
      tableWrapper.classList.add('c-table__container');
      el.parentNode.insertBefore(tableWrapper, el);
      tableWrapper.appendChild(el);
    });
  }
}

export default init;



// WEBPACK FOOTER //
// ./src/components/components/default/rte/mando-ui.rte-table.js